import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class CustactCalcService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Saves the given texts.
     *
     * @datatask 598
     * @datataskName sp_ws_p2_custact_save_w_custactcalcedit_text
     * @legacyName custactCalcService.saveEditText()
     * @param texts the list of texts to save.
     * @returns an empty promise.
     */
    public saveSubtaskTexts(texts: SubtaskTextItem[]): Promise<void> {
        return this.datatask.Post(598, { records: texts });
    }

    /**
     * Retrieves list of subtasks text for the given custact_no and optiontype.
     *
     * @datatask 597
     * @datataskName sp_ws_p2_w_custactcalc_subtasks_text_list
     * @legacyName custactCalcService.listSubTaskTexts()
     * @returns a promise containing list of subtask texts.
     */
    public getSubtaskTexts(params: GetSubtaskTextsParams): Promise<SubtaskTextItem[]> {
        return this.datatask.Post(597, params);
    }

    /**
     * Creates an order connected to the given custact_no in the params.
     *
     * @datatask 868
     * @datataskName sp_ws_p2_w_custactcalc_create_order
     * @legacyName custactCalcService.createOrder()
     * @param params
     * @returns a promise containing info about the order created and potential errorcode/message if creation failes.
     */
    public async createOrder(params: CustactCalcCreateOrderParams): Promise<CustactCalcCreateOrderResponse> {
        return (await this.datatask.Post(868, params))[0];
    }

    /**
     * Updates the production order components for the given custact_no in params.
     *
     * @datatask 869
     * @datataskName sp_ws_p2_w_custactcalc_update_po_components
     * @legacyName custactCalcService.updatePoComponents()
     * @param params
     * @returns a promise
     */
    public async updateProductionOrderComponents(params: UpdateProductionOrderComponentsParams): Promise<UpdateProductionOrderComponentsResponse> {
        return this.datatask.Post(869, params);
    }
}

export interface GetSubtaskTextsParams {
    custact_no: string | number;

    optiontype: string;

    /**
     * @default 'child'
     */
    retrievetype?: string;

    /**
     * @default '1'
     */
    include_top?: '1' | '0';
}

export interface SubtaskTextItem {
    custact_no: string | number;
    heading: string;
    text_sales: string;
    orderby: string | number;
    sortorderno: string | number;
    text_production: string;
    drawing_no: string;
}

export interface CustactCalcCreateOrderParams {
    custact_no: number | string;
    productsetting_keyno?: number | string;

    /**
     * @default 'child'
     */
    retrievetype?: string;

    /**
     * @default '1'
     */
    include_top?: '1' | '0';
}

export interface CustactCalcCreateOrderResponse {
    errorcode: string;
    errormessage: string;
    orderline_keyno: string | number;
    order_internal_no: string | number;
    po_keyno: string | number;
}

export interface UpdateProductionOrderComponentsParams {
    custact_no: number | string;

    /**
     * @default 'child'
     */
    retrievetype?: string;

    /**
     * @default '1'
     */
    include_top?: '1' | '0';
}

export interface UpdateProductionOrderComponentsResponse {}
